import React from 'react';

/**
 * Filet de sécurité : une erreur de rendu dans une page ne doit pas laisser un
 * écran blanc sans explication. On dit ce qui s'est passé, en français, et on
 * propose la seule action qui règle presque tout — recharger.
 *
 * Composant de classe par nécessité : React ne fournit pas de hook équivalent à
 * `getDerivedStateFromError`.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // La console garde la pile des composants : c'est là qu'on ira chercher la cause.
    console.error('[interface]', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    const { children, title = 'Cette page n\'a pas pu s\'afficher' } = this.props;
    if (!error) return children;
    return (
      <div className="container error-boundary" role="alert">
        <div className="card">
          <h2>{title}</h2>
          <p className="muted">
            Un problème est survenu pendant l'affichage. Recharger la page suffit le plus
            souvent ; si le défaut persiste, signalez-le avec le détail ci-dessous.
          </p>
          {error?.message && <pre className="error-detail">{String(error.message)}</pre>}
          <button type="button" className="btn" onClick={() => window.location.reload()}>
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}
